import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';
import { Dispatch } from '@manigo/manigo-commons';

import withAccessControl from 'hoc/withAccessControl';
import { requestNavigation } from 'store/navigation/actions';
import { RootState } from 'store/rootReducer';
import { newConsentReducerName } from 'store/new-consent/reducer';

import ConsentRequestErrors from './ConsentRequestErrors.layout';
import {
    ConsentRequestErrorsDispatchProps,
    ConsentRequestErrorsOwnProps,
    ConsentRequestErrorsStateProps,
} from './ConsentRequestErrors.types';


const mapStateToProps = (state: RootState): ConsentRequestErrorsStateProps => ({
    redirectionUrl: state[newConsentReducerName].newConsentCallbackUrl,
    //
});

const mapDispatchToProps = (dispatch: Dispatch): ConsentRequestErrorsDispatchProps => ({
    dispatchRequestNavigation: ({ locationPathname, meta }) => dispatch(requestNavigation({ locationPathname, meta })),
    //
});


const decorate = compose<ComponentType<ConsentRequestErrorsOwnProps>>(
    withTranslation('consent'),
    withAccessControl,
    connect(mapStateToProps, mapDispatchToProps),
);

export default decorate(ConsentRequestErrors);
